import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-on-surface text-white mt-auto">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">

          {/* Brand */}
          <div className="md:col-span-2">
            <span className="font-sans font-black text-2xl text-primary-container uppercase tracking-tighter">Central Fasteners</span>
            <p className="font-label text-[10px] uppercase tracking-[0.22em] text-gray-500 mt-0.5 mb-4">Strength. Precision. Relability</p>
            <p className="font-body text-sm text-gray-400 leading-relaxed max-w-xs">
              Authorized Distributor to sell the entire range of Unbrako & DFL High-Tenesile.
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-label text-xs uppercase tracking-widest text-gray-500 mb-4">Quick Links</h4>
            <nav className="space-y-2">
              {[
                ['/products',       'Products'],
                ['/price-list',     'Price List'],
                ['/how-to-measure', 'How to Measure'],
                ['/about',          'About Us'],
                ['/feedback',       'Feedback'],
              ].map(([to, label]) => (
                <Link key={to} to={to} className="block font-label text-sm text-gray-400 hover:text-primary-container transition-colors">{label}</Link>
              ))}
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-label text-xs uppercase tracking-widest text-gray-500 mb-4">Contact</h4>
            <div className="space-y-2 text-sm text-gray-400 font-body">
              <p className="flex items-start gap-2">
                <span className="material-symbols-outlined text-[16px] text-gray-500 mt-0.5">mail</span>
                centralfastenerspune@gmail.com
              </p>
              <p className="flex items-start gap-2">
      <span className="material-symbols-outlined text-[16px] text-gray-500 mt-0.5">phone</span>
      <a
        href="tel:+91 98222 51329"
        className="hover:underline"
      >
        +91 98222 51329
      </a>
      
    </p>
    <p> Note: Calls will be answered only during working hours (10:00 AM – 7:00 PM).</p>
              <p className="flex items-start gap-2">
              <span className="material-symbols-outlined text-[16px] text-gray-500 mt-0.5">
                location_on
                </span>
                <a
                href="https://maps.app.goo.gl/ssLeNrYwmP7h6MbB7"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:underline" >
                  Central Fasteners, Pune, Maharashtra, India
                  </a>
                  </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-label text-xs text-gray-600 uppercase tracking-widest">
            © {new Date().getFullYear()} Central Fasteners. All Rights Reserved.
          </p>
          <p className="font-label text-xs text-gray-600">
            centralfasteners.in
          </p>
        </div>
      </div>
    </footer>
  );
}
